import './index.css';

export default {
  name: 'Acard',
  props: {
    title: null,
    id: { type: String, default: () => (`a-card-${Math.random().toString().substring(2)}`) },
    dragType: { type: String, default: () => 'text/plain' },
    draggable: { type: Boolean, default: () => true },
    insert: { type: Boolean, default: () => false },
    flex: { type: Boolean, default: () => true },
    path: { type: String, default: () => '' },
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: () => false },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      // TODO
    },
    dragstart(a) {
      if (this.draggable) {
        a.dataTransfer.setData(this.dragType, this.id);
        this.$store.commit('setDragId', this.id);
        this.$emit('dragstart', a);
      }
    },
    dragenter(a) {
      a.preventDefault();
      this.$emit('dragenter', a);
    },
    dragleave(a) {
      a.preventDefault();
      this.$emit('dragleave', a);
    },
    dragover(a) {
      a.preventDefault();
      this.$emit('dragover', a);
    },
    dragend(a) {
      a.preventDefault();
      this.$emit('dragend', a);
    },
    drag(a) {
      a.preventDefault();
      this.$emit('drag', a);
    },
    drop(a) {
      a.preventDefault();
      if (this.draggable) {
        const id = a.dataTransfer.getData(this.dragType);
        const draging = document.getElementById(id);
        const droping = document.getElementById(this.id);
        if (draging !== droping) {
          let dragPostion = draging.getBoundingClientRect();
          let dropPostion = droping.getBoundingClientRect();
          if (this.insert) {
            if (this.getIndex(draging) > this.getIndex(droping)) {
              this.$el.parentNode.insertBefore(draging, droping);
            } else {
              this.$el.parentNode.insertBefore(draging, droping.nextSibling);
            }
          }
          this.animate(draging, dragPostion);
          this.animate(droping, dropPostion);
        }
        this.$store.commit('setDropId', this.id);
        this.$emit('drop', a);
      }
    },
    getIndex(element = null) {
      let index = 0;
      if (!element) return -1;
      while (element = element.previousSibling) index++;
      return index;
    },
    animate(element, postion, delay = 300) {
      let current = element.getBoundingClientRect();
      let action = (() => {
        element.style.transition = 'none';
        element.style.transform = `translate3d(${postion.left - current.left}px, ${postion.top - current.top}px, 0)`
        element.offsetWidth;
        element.style.transition = `all ${delay}ms`;
        element.style.transform = 'translate3d(0, 0, 0)';
      })();
      let timeout = null;
      if (timeout) {
        action = null;
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          action = null;
          clearTimeout(timeout);
          timeout = null;
        }, delay);
      }
    },
    mousedown(a, b) {
      // TODO
      return false;
    },
    mouseup(a, b) {
      // TODO
      return false;
    },
    mouseover(a, b) {
      // TODO
      return false;
    },
    review() {
      this.$emit('review', this.$attrs);
    },
    select(path) {
      this.$emit('select', path);
    },
    cancel(path) {
      this.$emit('cancel', path);
    },
  },
  render() {
    const {
      padding = '14px',
      margin = '0',
      height = '',
      color = '',
      background = 'rgba(255, 255, 255, 0.875)',
      headStyle = {},
      bodyStyle = {},
      footStyle = {},
      disabled = false,
      finishText = '保存',
      submitText = '提交',
      repealText = '废除',
      rejectText = '驳回',
      cancelText = '取消',
      reviewText = '',
      action = [],
      ...attrs
    } = this.$attrs;
    const { finish = null, submit = null, repeal = null, reject = null, cancel = null } = this.$listeners;
    const loading = this.loading || disabled || false;
    return (
      <div
        id={this.id}
        class={['a-card', (this.flex ? 'flex' : null)]}
        on-dragstart={this.dragstart}
        on-dragenter={this.dragenter}
        on-dragleave={this.dragleave}
        on-dragover={this.dragover}
        on-dragend={this.dragend}
        on-drag={this.drag}
        on-drop={this.drop}
        style={{ margin, color, height, background }}
        {...{ attrs }}
      >
        {this.title && (
          <div class={['a-card-head', (this.draggable ? 'draggable' : null)]} draggable={this.draggable} style={{ ...headStyle }}>
            <span class="text">{this.title}</span>
            {reviewText != '' && (<span class="link" on-click={() => this.review()}>{reviewText}</span>)}
            {this.$slots.header}
          </div>
        )}
        <div class="a-card-body" on-click={this.select} style={{ padding, ...bodyStyle }}>
          <div class="a-card-body-main">
            {this.$slots.default}
          </div>
        </div>
        {(finish || submit || repeal || reject || cancel || action.length > 0) && (
          <div class="a-card-foot" style={{ padding, marginBottom: `${parseInt(padding)}px`, ...footStyle }}>
            {finish && <el-button class="finish" on-click={finish} size="small" disabled={loading} type="success">{finishText}</el-button>}
            {submit && <el-button class="submit" on-click={submit} size="small" disabled={loading} type="primary">{submitText}</el-button>}
            {repeal && <el-button class="repeal" on-click={repeal} size="small" disabled={loading} type="warning">{repealText}</el-button>}
            {reject && <el-button class="reject" on-click={reject} size="small" disabled={loading} type="danger">{rejectText}</el-button>}
            {cancel && <el-button class="cancel" on-click={this.cancel} size="small" disabled={loading}>{cancelText}</el-button>}
            {action.map((a, b) => (
              <el-button class={`button-${b + 1}`} key={b} disabled={loading} on-click={a.click} {...{ attrs: a }}>
                {a.label || a.title || a.text || ''}
              </el-button>
            ))}
          </div>
        )}
        {this.$slots.footer}
      </div>
    );
  }
}
